// extracted by mini-css-extract-plugin
module.exports = {"main":"search_main__2hPPM","resultative":"search_resultative__2ycFH"};